import { useMemo } from "react";

import useCopyToClipboard from "hooks/useCopyToClipboard";
import { CallbackTrack } from "hooks/useAnalytics";
import { Copy } from "components/icons/generated";

import { TableCellAction } from "../Row/CellContent";

type MakeUseCellCopyActionProps = {
  trackAnalytics?: CallbackTrack;
};

export type UseCellCopyActionProps = {
  column?: string;
  text: string;
};

const makeUseCellCopyAction = ({ trackAnalytics }: MakeUseCellCopyActionProps = {}) => {
  const useCellCopyAction = ({ column, text }: UseCellCopyActionProps): TableCellAction => {
    const action = useCopyToClipboard(text, () => {
      if (column && trackAnalytics) {
        trackAnalytics("Copy cell content clicked", { column });
      }
    });

    return useMemo(
      () => ({
        icon: Copy,
        title: "Copy",
        onPress: action,
      }),
      [action]
    );
  };

  return useCellCopyAction;
};

export default makeUseCellCopyAction;
